import { HAS_WINDOW } from '@eventbrite/feature-detection';
import { CheckoutState } from '../../state';

export const getIsAppRebrandActive = ({ app }: CheckoutState) => {
    const appRebrandParam =
        app?.request?.params?.is_app_rebrand_active ||
        (HAS_WINDOW
            ? new URLSearchParams(window.location.search).get(
                  'is_app_rebrand_active',
              )
            : null);

    return appRebrandParam === 'true';
};
